const ImagePicker = {
  show: (buttonRef, successCallback, cancelCallback = null, alternateTakePictureInitiator = null, fileRef) => {
    fileRef.open()
  }
}

export default ImagePicker
